import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=6da9774f&scoped=true&"
import script from "./Edit.vue?vue&type=script&lang=js&"
export * from "./Edit.vue?vue&type=script&lang=js&"
import style0 from "./Edit.vue?vue&type=style&index=0&id=6da9774f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da9774f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6da9774f')) {
      api.createRecord('6da9774f', component.options)
    } else {
      api.reload('6da9774f', component.options)
    }
    module.hot.accept("./Edit.vue?vue&type=template&id=6da9774f&scoped=true&", function () {
      api.rerender('6da9774f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/directories/Edit.vue"
export default component.exports